if (!(Object as any).hasOwn) {
  (Object as any).hasOwn = (obj: object, prop: string) => Object.prototype.hasOwnProperty.call(obj, prop);
}
